import InstoreForm from './InstoreForm';

export default InstoreForm;
